import React from "react";

const LANGS = [
  { code: "es", label: "ES" },
  { code: "en", label: "EN" },
  { code: "pt", label: "PT" },
];

const getQueryParam = (param) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
};

const LanguageSwitcher = () => {
  const currentLang = getQueryParam("lng") || "es";

  return (
    <div
      className="inline-flex items-center flex-shrink-0"
      style={{
        border: "1px solid rgba(0,0,0,0.12)",
        borderRadius: "6px",
        overflow: "hidden",
        height: "30px",
      }}
    >
      {LANGS.map(({ code, label }, i) => {
        const isActive = currentLang === code;
        return (
          <a
            key={code}
            href={`?lng=${code}`}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "34px",
              height: "100%",
              fontSize: "10px",
              fontWeight: 700,
              letterSpacing: "0.04em",
              fontFamily: '"Inter", sans-serif',
              textDecoration: "none",
              background: isActive ? "#010C66" : "transparent",
              color: isActive ? "#ffffff" : "#6b7280",
              borderRight: i < LANGS.length - 1 ? "1px solid rgba(0,0,0,0.1)" : "none",
              transition: "background 0.15s, color 0.15s",
            }}
          >
            {label}
          </a>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
